/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type PdpSharedShippingInfo_regionalInfo = ReadonlyArray<{
    readonly regionsByZipCode: ReadonlyArray<{
        readonly displayName: string | null;
    } | null> | null;
    readonly " $refType": "PdpSharedShippingInfo_regionalInfo";
}>;
export type PdpSharedShippingInfo_regionalInfo$data = PdpSharedShippingInfo_regionalInfo;
export type PdpSharedShippingInfo_regionalInfo$key = ReadonlyArray<{
    readonly " $data"?: PdpSharedShippingInfo_regionalInfo$data;
    readonly " $fragmentRefs": FragmentRefs<"PdpSharedShippingInfo_regionalInfo">;
}>;



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "PdpSharedShippingInfo_regionalInfo",
  "type": "RegionalInfo",
  "metadata": {
    "plural": true
  },
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "regionsByZipCode",
      "storageKey": null,
      "args": null,
      "concreteType": "RegionsByZipCode",
      "plural": true,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "displayName",
          "args": null,
          "storageKey": null
        }
      ]
    }
  ]
};
(node as any).hash = '4143037d705b38feb17a86b3be36f145';
export default node;
